<div class='se-buttons-toolbar-main-container se-flex'>
    <!-- Visualizza\nasconde il menu di navigazione -->
    <mat-slide-toggle *ngIf="leftSliderOptions?.visible" #headerSlideButtons
                      class="se-buttons-toolbar-toggle-left"
                      [disabled]="!leftSliderOptions.enabled || disableAll"
                      [checked]="leftSliderChecked"
                      (change)="onLeftSliderChange($event)"
                      [matTooltip]="getLeftTooltip"
                      matTooltipPosition="right"
                      matTooltipShowDelay="500">
    </mat-slide-toggle>

    <mat-divider class="se-header-divider" *ngIf="leftSliderOptions?.visible" [vertical]="true"></mat-divider>

    <!-- BACK -->
    <button *ngIf="backVisible" #headerBackButtons mat-icon-button
            class="se-button-no-ripple--buttons-toolbar"
            [disabled]="disableAll" [matTooltip]="'PreviousPage' | translate"
            matTooltipPosition="above" (click)="onBackClick()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div #headerButtonsContainer class='se-buttons-toolbar-buttons-container'>
        <div *ngFor="let button of buttonsList; trackBy: getButtonAction" class='se-buttons-toolbar-button-container'>

            <!-- Pulsanti senza sottomenu-->
            <button mat-button class="se-buttons-toolbar-button" [attr.action-type]="button.actionType"
                    [disabled]="button.status.disabled || disableAll" *ngIf="getVisibilityToolbar(button)"
                    [class.se-buttons-toolbar-button-checked]="button.isToggle && button.status.checked"
                    (click)="onToolbarClickEvent(button)">
                <span translate>{{button.label}}</span>
            </button>

            <!-- Pulsanti con sottomenu liv1-->
            <div class='se-buttons-toolbar-button-container'>
                <mat-menu #visibleButtonMenu="matMenu" class="se-mat-menu">
                    <div matMenuContent *ngFor="let child of button.children">
                        <button mat-menu-item class='se-buttons-toolbar-menu-button se-menu-button'
                                [attr.action-type]="child.actionType" [disabled]="child.status.disabled || disableAll"
                                *ngIf="child.status.visible"
                                [class.se-buttons-toolbar-button-checked]="child.isToggle && child.status.checked"
                                (click)="onToolbarClickEvent(child)">
                            <span translate>{{child.label}}</span>
                        </button>
                    </div>
                </mat-menu>
                <button mat-button class="se-buttons-toolbar-button se-menu-buttons-toolbar-button"
                        *ngIf="getVisibilityChildrenToolbar(button)"
                        [attr.action-type]="button.actionType"
                        [disabled]="button.status.disabled || disableAll"
                        [matMenuTriggerFor]="visibleButtonMenu">
                    <span translate>{{button.label}}</span>
                </button>
                <mat-icon class='se-buttons-toolbar-submenu-icon'
                          [class.toolbar-submenu-icon-disabled]="button.status.disabled || disableAll"
                          *ngIf="getVisibilityChildrenToolbar(button)">arrow_drop_down</mat-icon>
            </div>
        </div>
    </div>

    <button mat-icon-button [matMenuTriggerFor]="hideButtonsMainMenu"
            class='se-buttons-toolbar-more-button'
            [class.visible]="isMoreButtonVisible()">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #hideButtonsMainMenu="matMenu" class="se-mat-menu">
        <div matMenuContent *ngFor="let button of hideButtonsList">

            <!-- Pulsanti nascosti senza sottomenu-->
            <button mat-menu-item class='se-buttons-toolbar-menu-button se-menu-button'
                    [attr.action-type]="button.actionType" [disabled]="button.status.disabled || disableAll"
                    *ngIf='getVisibilityToolbar(button)'
                    [class.se-buttons-toolbar-button-checked]="button.isToggle && button.status.checked"
                    (click)="onToolbarClickEvent(button)">
                <span translate>{{button.label}}</span>
            </button>

            <!-- Pulsanti nascosti con sottomenu liv1-->
            <button mat-menu-item class='se-buttons-toolbar-menu-button se-menu-button'
                    [attr.action-type]="button.actionType" [disabled]="button.status.disabled || disableAll"
                    *ngIf='getVisibilityChildrenToolbar(button)' [matMenuTriggerFor]="hideButtonSubMenu">
                <span translate>{{button.label}}</span>
            </button>
            <mat-menu #hideButtonSubMenu="matMenu" class="se-mat-menu">
                <div *ngFor="let child of button.children">
                    <button mat-menu-item class='se-buttons-toolbar-menu-button se-menu-button'
                            [attr.action-type]="child.actionType" [disabled]="child.status.disabled || disableAll"
                            *ngIf="child.status.visible"
                            [class.se-buttons-toolbar-button-checked]="child.isToggle && child.status.checked"
                            (click)="onToolbarClickEvent(child)">
                        <span translate>{{child.label}}</span>
                    </button>
                </div>
            </mat-menu>
        </div>
    </mat-menu>

    <!-- Bottone per toggle sezione timeline -->
    <se-timeline-toggle *ngIf="timelineOptions && timelineOptions.active" #timelineToggle (toggleTimeline)="_onTimelineToggle($event)" [toggleOpen]="timelineOptions.open"></se-timeline-toggle>

</div>
